"use client";
import { useTranslations } from "next-intl";
import { Link, useRouter } from "@/navigation";
import { useRef, useState } from "react";
import { useEffect } from "react";
export default function ShopByCate() {
	const t = useTranslations("");
	const [isPlaying, setIsPlaying] = useState(false);
	const videoRef = useRef<HTMLVideoElement>(null);

	const handlePlay = () => {
		if (videoRef.current) {
			videoRef.current.play();
			setIsPlaying(true);
		}
	};

	const handleVideoClick = () => {
		if (videoRef.current) {
			if (!videoRef.current.paused) {
				videoRef.current.pause();
				setIsPlaying(false);
			}
		}
	};
	useEffect(() => {
		if (videoRef.current) {
			const playPromise = videoRef.current.play();
			if (playPromise !== undefined) {
				playPromise
					.then(() => {
						setIsPlaying(true);
					})
					.catch(() => {
						setIsPlaying(false);
					});
			}
		}
	}, []);
	return (
		<div>
			<div className="container max-md:my-5 md:my-10 ">
				<div
					style={{ position: "relative", width: "100%" }}
					className="h-[700px] bg-black max-2xl:h-[500px] max-xl:h-[380px] max-lg:h-full"
				>
					<video
						ref={videoRef}
						src="/image/home/vd.mp4"
						muted
						loop
						playsInline
						autoPlay
						className=" h-full w-full max-xl:px-[150px] max-lg:h-auto max-lg:w-full max-lg:px-0 xl:px-[240px]"
						style={{ display: "block" }}
						onClick={isPlaying ? handleVideoClick : undefined}
					/>
					{!isPlaying && (
						<div
							style={{
								position: "absolute",
								top: 0,
								left: 0,
								width: "100%",
								height: "100%",
								background: "rgba(0,0,0,0.5)",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								cursor: "pointer",
								zIndex: 2,
							}}
							onClick={handlePlay}
						>
							<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
								<circle cx="32" cy="32" r="32" fill="rgba(0,0,0,0.6)" />
								<polygon points="26,20 48,32 26,44" fill="#fff" />
							</svg>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}
